import React from 'react';
import { CButton, CContainer, CImg, CModal, CModalBody, CRow } from '@coreui/react';
import logo from '../assets/images/glympse-pro-white.png';

interface Props {
  stepIndex: number,
  currentStepIndex: number,
  handleNext: Function,
  handleNotNow: Function,
  endWalkthrough: Function,
  showWalkthrough: boolean,
  userStartedTour: boolean,
  title: string,
  currentStepDotsLength: number,
  content: string,
}

function WalkThroughModal(props: Props) {
  const {
    stepIndex,
    currentStepIndex,
    currentStepDotsLength,
    handleNext,
    handleNotNow,
    endWalkthrough,
    showWalkthrough,
    userStartedTour,
    title,
    content,
  } = props;
  const welcomeStep = stepIndex === 0;
  const lastStep = stepIndex === 6;

  return (
    <CModal
      show={(stepIndex === currentStepIndex) && (showWalkthrough || userStartedTour)}
      closeOnBackdrop={false}
      className={`walkthrough-focus-modal onboarding-step ${welcomeStep ? 'onboarding-step--first' : ''} ${lastStep ? 'lastStep' : ''}`}
    >
      <CModalBody>
        <CContainer className="my-3">
          {welcomeStep &&
            <CRow className="justify-content-center my-3">
                <CImg
                  className="c-sidebar-brand-full"
                  src={logo}
                  height="30"
                />
            </CRow>
          }
          <CRow className={`${welcomeStep ? "justify-content-center my-2 onboarding-modal-text" : "onboarding-modal-title"}`}>{title}</CRow>
          <CRow className={`${welcomeStep ? "justify-content-center my-2" : ""} onboarding-modal-text`}>{content}</CRow>
          {welcomeStep && 
            <CRow className="justify-content-center my-2 onboardingBtnsContainer">
                <CButton className="bg-color-orange border-0 roundedBtn onboardingBtn" color="primary" onClick={handleNext}>
                  Take a Tour!
                </CButton>
                <CButton color="primary" className="bg-color-orange border-0 roundedBtn onboardingBtn" onClick={handleNotNow}>
                  Not now
                </CButton>
                <CButton color="primary" className="bg-color-orange border-0 roundedBtn onboardingBtn" onClick={endWalkthrough}>
                  Skip
                </CButton>
            </CRow>
          }
          {!welcomeStep && 
            <CRow className="justify-content-center my-2 onboardingBtnsContainer">
                <CButton className="border-0 roundedBtn onboardingBtn onboardingBtn--skip" onClick={endWalkthrough}>
                  SKIP TOUR
                </CButton>
                <div className="dotsContainer">
                  {Array.from(Array(currentStepDotsLength + 1).keys()).map(num => (
                    <div
                      key={`step-${num}`}
                      role="button"
                      tabIndex={-1}
                      aria-label="Go to step button"
                      onClick={() => handleNext(num)}
                      onKeyPress={() => handleNext(num)}
                      className={`linkDot ${(currentStepIndex === num) ? 'active' : ''}`}
                    />
                  ))}
                </div>
                <CButton className="bg-color-orange border-0 roundedBtn onboardingBtn" color="primary" onClick={handleNext}>
                  {lastStep ? "End" : "Next"}
                </CButton>
            </CRow>
          }
        </CContainer>
      </CModalBody>
    </CModal>
  );
}

export default WalkThroughModal;